import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { CommentaryModule } from '../../modules/commentary/CommentaryModule.tsx';
import { selectIsCommentaryLoaded } from '../../redux/features/selectors/commentarySelectors/selectIsCommentaryLoaded.ts';
import { useAppSelector } from '../../redux/hooks.ts';

export const CommentaryRouteElement = () => {
  const isLoaded = useAppSelector((state) => selectIsCommentaryLoaded(state));

  return (
    <ModuleContainer moduleID="commentary" compact>
      {isLoaded && <CommentaryModule />}
    </ModuleContainer>
  );
};
